import {
  Button,
  Text,
  useComputedColorScheme,
  useMantineTheme,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import {
  FillLayerSpecification,
  GeoJSONFeatureId,
  MapLibreEvent,
} from "maplibre-gl";
import { default as React, useEffect, useRef, useState } from "react";
import Map, {
  FullscreenControl,
  Layer,
  MapRef,
  Source,
} from "react-map-gl/maplibre";
import * as turf from "@turf/turf";
import { Feature, FeatureCollection, LineString, Point } from "geojson";
import maplibregl from "maplibre-gl";
import carImage from "../../../assets/auto.png";
import planeImage from "../../../assets/plane.png";
import { bearing, point } from "@turf/turf";
import { useAppSelector } from "src/app/hooks";
import MapOverlayButton from "src/components/mapView/MapOverlayButton";
import { HiArrowRight, HiArrowsExpand } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import { isMap } from "util/types";

const mapStyleJsons = {
  positron: "https://tiles.openfreemap.org/styles/positron",
};

export default function Globe(props: { interactive?: boolean }) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.xs})`);
  const colorScheme = useComputedColorScheme();
  const mapRef = useRef<MapRef>(null);
  const initializedRef = useRef(false);
  const [animationData, setAnimationData] = useState(null);
  const [countriesGeoJSON, setCountriesGeoJSON] = useState<any>({});
  const [zoom, setZoom] = useState(3);
  const locationState = useAppSelector((state) => state.location);
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    import("../../../assets/countries.geo.json").then((module) => {
      const countriesRaw = module.default;
      setCountriesGeoJSON({
        ...countriesRaw,
        features: countriesRaw["features"].map((feature, index) => ({
          ...feature,
          id: index, // or use a hash of a property like `feature.properties.name`
        })),
      });
    });
  }, []);

  const onLoadMap = (event: MapLibreEvent) => {
    setIsMapLoaded(true);

    event.target.getStyle().layers.forEach((l) => {
      //console.log(l);
      /*if (l.type == "symbol" && l.id.startsWith("label")) {
        console.log(l);

        event.target.setLayoutProperty(l.id, "text-field", [
          "get",
          "name",
        ]);
        //event.target.setLayoutProperty(l.id, "text-visibility", 0);
        event.target.setLayoutProperty(l.id, "text-size", 16);
      }*/

      if (l.id == "countries-layer-with-locations") {
        //event.target.setLayoutProperty(l.id, "visibility", "visible");
      }
    });
  };

  const updateHighlightedCountries = () => {
    countriesGeoJSON.features.forEach((feature) => {
      if (
        locationState.locations.find(
          (location) =>
            location.countryCode === feature.properties["ISO3166-1-Alpha-2"]
        ) &&
        zoom < 4
      ) {
        mapRef.current.setFeatureState(
          {
            source: "countries",
            id: feature.id,
          },
          { hasLocations: true }
        );
      } else {
        mapRef.current.setFeatureState(
          {
            source: "countries",
            id: feature.id,
          },
          { hasLocations: false }
        );
      }
    });
  };

  // Highlight countries with locations
  useEffect(() => {
    if (
      !isMapLoaded ||
      !mapRef?.current ||
      !countriesGeoJSON?.features ||
      !mapRef.current.isStyleLoaded() ||
      locationState.locations.length === 0
    )
      return;
    updateHighlightedCountries();
  }, [locationState.locations, isMapLoaded]);

  const layerStyleWithLocations: FillLayerSpecification = {
    id: "countries-layer-with-locations",
    type: "fill",
    source: "countries",
    layout: {},
    paint: {
      "fill-color": "dodgerblue",
      "fill-opacity": [
        "case",
        ["boolean", ["feature-state", "hasLocations"], false],
        0.5,
        0,
      ],
    },
  };

  /*const isInteractive = () => {
    if (isMobile) {
      return isFullscreen && props.interactive;
    }
    return props.interactive;
  };*/

  return (
    <div className="flex flex-col w-full h-full gap-4">
      <div className="w-full h-full rounded-lg border border-grey-800 overflow-hidden mt-[1rem]">
        <Map
          id="mapData2"
          reuseMaps
          initialViewState={{
            longitude: 9.389839,
            latitude: 50.622884 - 10,
            zoom: 1,
          }}
          style={{ width: "100%", height: "100%" }}
          mapStyle={mapStyleJsons.positron}
          onLoad={(event: MapLibreEvent) => {
            onLoadMap(event);
          }}
          interactive={props.interactive}
          projection={"globe"}
          attributionControl={false}
          minZoom={1}
          maxZoom={5}
          ref={mapRef}
        >
          <Source id="countries" type="geojson" data={countriesGeoJSON}>
            <Layer {...layerStyleWithLocations} />
          </Source>

          {/* <FullscreenControl position="top-left" /> */}

          {/* <MapOverlayButton
            icon={<HiArrowRight />}
            style={{
              pointerEvents: "all",
            }}
            onClick={() => {
              navigate("/map");
            }}
          /> */}
        </Map>
      </div>
    </div>
  );
}
